import { Card } from "react-bootstrap";

import { GIT_STRING } from "../constants";

export const Footer = () => (
	<footer className="footer" data-testid="test-footer">
		<p className="mb-0 mt-2 me-5 p-0">
			<small style={{ fontSize: "0.7rem" }}>
				<span className="text-charcoal-500">
					Gloria in Excelsis Deo ✝
				</span>
				<br />
				<span className="text-charcoal-500">{GIT_STRING}</span>
				<br />
				<Card.Link
					href="https://austinpowder.com"
					target="_blank"
					className="text-muted text-decoration-none fw-normal"
				>
					Austin Powder © 2020 - 2025
				</Card.Link>
			</small>
		</p>
	</footer>
);
